import { markRaw } from 'vue'

import JobHistorySidebarTab from '@/components/sidebar/tabs/JobHistorySidebarTab.vue'
import { useNordyQueueStore } from '@/nordy/store/nordyQueueStore'
import { useSidebarTabStore } from '@/stores/workspace/sidebarTabStore'
import type { SidebarTabExtension } from '@/types/extensionTypes'

export const useJobHistorySidebarTab = (): SidebarTabExtension => {
  return {
    id: 'job-history',
    icon: 'icon-[lucide--history]',
    title: 'queue.jobHistory',
    tooltip: 'queue.jobHistory',
    label: 'queue.jobHistory',
    component: markRaw(JobHistorySidebarTab),
    type: 'vue',
    iconBadge: () => {
      const sidebarTabStore = useSidebarTabStore()
      if (sidebarTabStore.activeSidebarTabId === 'job-history') {
        return null
      }

      //!nordy - Job History 배지 카운트를 Nordy 큐 스토어 기준으로 계산
      const queueStore = useNordyQueueStore()
      const count = queueStore.queueCount.count
      return count > 0 ? count.toString() : null
    }
  }
}
